import api from "services/api";
import { API_URL_VERSION } from "constants/environment";

const ENDPOINT_DASHBOARD_ESTATISTICAS = API_URL_VERSION + "dashboard/estatisticas";

export const dashboardService = {
  getStatistics: async () => {
    const response = await api.get(ENDPOINT_DASHBOARD_ESTATISTICAS);
    return response.data;
  },
};
